import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { NavEntryPoint } from '@retailer-platform/dashboard/routing'
import { fulfillmentSettingsRouter } from './routing/fulfillmentSettingsRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import EN_US from './translations/en-US.json'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { listFulfillmentRulesPageAccessControl } from './access-control/listFulfillmentRulesPageAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'fulfillment-settings',
  totem: {
    tool: 'fulfillment-settings-dashboard-tool',
  },
  routes,
  translations: { EN_US },
  lazyTranslations: {
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  routers: {
    scoped: [fulfillmentSettingsRouter],
  },
  navigationEntries: [
    {
      attachToV2: NavEntryPoint.OperationsGeneral,
      subNavItems: [
        {
          type: 'item',
          llmDescription:
            'Manage order orchestration rules for delivery routing and fulfillment service providers',
          labelId: 'fulfillmentSettingsDomain.listFulfillmentRulesPage.title',
          route: 'fulfillment-settings-list-fulfillment-rules',
          position: 10,
          positionNavV2: 10,
          accessControl: listFulfillmentRulesPageAccessControl,
        },
      ],
    },
  ],
  adminNavigationEntries: [],
}

export default definition
